import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Context } from 'src/app/shared/models/context';
import { Leave, Message, PrivilegeType } from 'src/app/shared/models/domain';
import { AppearanceService } from 'src/app/shared/services/appearance.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { DataService } from 'src/app/shared/services/data.service';

@Component({
  selector: 'app-regular-approval',
  templateUrl: './regular-approval.component.html',
  styleUrls: ['./regular-approval.component.scss']
})
export class RegularApprovalComponent implements OnInit {
  public approvals: Leave[] = [];
  public context: Context;
  public status: string = 'APPLIED';
  public tempStatus: string = 'APPLIED';
  public fromDate: string;
  public toDate: string;
  public isLoading: boolean = true;
  public privilege: PrivilegeType;
  public statuses: string[] = [];
  public currentTab: string = 'APPROVAL';

  constructor(
    private authService: AuthService,
    private commonService: CommonService,
    private appearanceService: AppearanceService,
    private datePipe: DatePipe,
    private dataService: DataService
  ) { }

  ngOnInit(): void {
    this.dataService.privilege().subscribe(privilege => { this.privilege = this.commonService.getPrivileges(privilege) });
    this.fromDate = this.datePipe.transform(this.commonService.adjustDateByDays(-30), 'yyyy-MM-dd');
    this.toDate = this.datePipe.transform(this.commonService.adjustDateByDays(30), 'yyyy-MM-dd');
    this.context = this.authService.getContextData();
    if (this.context && this.context?.companyId) {
      this.getApprovalStatus();
      this.getApprovals();
    }
  }

  private getApprovals(clear: boolean = true) {
    if (this.context?.employeeId) {
      if (clear) {
        this.isLoading = true;
        this.approvals = [];
      }
      if (!this.fromDate || !this.toDate) {
        this.commonService.setToastr(500, "Both \"From Date\" and \"To Date\" are required to proceed.");
        return;
      }
      const fromDate = this.datePipe.transform(this.fromDate, 'dd-MM-yyyy');
      const toDate = this.datePipe.transform(this.toDate, 'dd-MM-yyyy');
      this.appearanceService.getRegularApprovals(this.context.employeeId, fromDate, toDate, this.status).subscribe({
        next: (approvals: Leave[]) => {
          this.approvals = approvals.sort((a, b) => a.id - b.id);
          this.isLoading = false;
        },
        error: (error: HttpErrorResponse) => {
          this.isLoading = false;
          this.commonService.setToastr(500, error?.error?.name || error.error);
        }
      });
    } else {
      this.isLoading = false;
    }
  }

  private getApprovalStatus() {
    this.appearanceService.getStatus().subscribe((statuses) => {
      this.statuses = statuses.filter(s => s !== 'COMPLETED'&& s !== 'CANCELLED');
    });
  }

  public onStatusChange() {
    this.getApprovals(false);
    this.tempStatus = this.status;
  }

  public approveRegular(approval: Leave, inProgress: any, status: string, index: number) {
    if (!this.privilege.canEdit) {
      setTimeout(() => { approval.approvedOn = !approval.approvedOn }, 0);
      return;
    }
    if(approval.comments) {
    let approvalData: Leave = JSON.parse(JSON.stringify(approval));
    approvalData.status = status;
    inProgress.value = true;
    this.appearanceService.Regularapproval({ regularData: [approvalData] }).subscribe({
      next: (response: Message) => {
        inProgress.value = false;
        if (!response.failed) {
          this.commonService.setToastr(200, `Regular for ${approvalData.appliedFor.name} has been ${approvalData.status}`);
          this.approvals.splice(index, 1);
          this.getApprovals(false);
        }
      },
      error: (error: HttpErrorResponse) => {
        inProgress.value = false;
        this.commonService.setToastr(500, error?.error?.name || error.error);
      },
    });
  }else {
    this.commonService.setToastr(500,"Please enter comments");
  }
}
}
